module.exports = __webpack_public_path__ + "js/0.0abe9646.worker.js"